import { createApi } from '@reduxjs/toolkit/query/react'

import { rtkBaseQuery } from 'Src/api'

export const trainingApiWithAI = createApi({
  baseQuery: rtkBaseQuery,
  reducerPath: 'trainingApiWithAI',
  tagTypes: ['TrainingListWithAI'],
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    getTrainingListWithAI: builder.query({
      query: (params) => {
        return {
          method: 'GET',
          url: '/v1/ai/training',
          params
        }
      },
      providesTags: ['TrainingListWithAI']
    }),
    getRelevantContent: builder.query({
      query: (params) => {
        return {
          method: 'GET',
          url: '/v1/ai/training/content/search',
          params
        }
      }
    }),
    updateAITrainingFeedback: builder.mutation({
      query: (body) => {
        return {
          method: 'POST',
          url: `/v1/ai/training`,
          body
        }
      },
      invalidatesTags: ['TrainingListWithAI']
    })
  })
})

export const { useGetTrainingListWithAIQuery, useLazyGetRelevantContentQuery, useUpdateAITrainingFeedbackMutation } =
  trainingApiWithAI

export default trainingApiWithAI
